import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoaderComponent } from './components/loader/loader.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SharedModule } from './components/shared.module';
import { AuthInterceptor } from './services/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SuccessPaymentComponent } from './pages/success-payment/success-payment.component';
import { CommonHeadersInterceptor } from './services/http-common-headers.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    LoginComponent,
    NotFoundComponent,
    SuccessPaymentComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot(
      {
        timeOut: 4000,
        positionClass: 'toast-top-full-width',
        preventDuplicates: true,
      }
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CommonHeadersInterceptor,
    //   multi: true
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
